const STORE_KEY = 'RECOVERY_EMAIL_POPUP'

export const IS_RECOVERY_EMAIL_POPUP_VISIBLE = `${STORE_KEY}/IS_VISIBLE`
export const WAS_RECOVERY_EMAIL_POPUP_SENT = `${STORE_KEY}/WAS_SENT`
